module.exports = __webpack_public_path__ + "static/media/slider3.956b0190.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/images/slider3.jpeg
// module id = 304
// module chunks = 0